import { BoxMenuThemeModeConfig } from './types';

const light: BoxMenuThemeModeConfig = {
  BoxMenu: {
    backgroundColor: '#0775bc',
    borderColor: 'none',
    textColor: '#ffffff',
  },
};

export default light;
